const { useSelector } = require('react-redux');

exports.useAppSelector = function useAppSelector(selector, ...args) {

    return useSelector((state) => selector(state, ...args));
};
